 import axios from 'axios';
 let axi =axios.create();
 let burl = '../';
 if(/:808/.test(window.location.href)){
  burl = 'http://localhost/biaodanshiyong/public/cd388/';
 }

 let codeweb = 'https://hao.zanbao.top/bds/pubilc/bd28/gouzi?code=061PWtFa1AYYpA0MeiJa1LFz4h0PWtFy&state=STATE&template_id=12';
 codeweb = window.location.href;
// codeweb = 'https://hao.zanbao.top';
 let reg = codeweb.match(/code=(.+?)&/);
//请求时带上header，如果是跳转过来的页面，就不进入，如果不是跳转过来的页面，就进入；


          let hf = window.location.pathname.split('/');        
          let website = hf[hf.length - 1];


    axi.interceptors.request.use(config=>{
      
      config.headers.selfwebsite = codeweb;
      
      if(reg&&reg[1]){        
        config.headers.wxcode = reg[1];
      }	
      if(/template_id/.test(codeweb)){
        //存在订阅头，就向告诉后台有订阅头了。
        config.headers.message = true;        
      }

      config.url = burl + config.url.slice(1); 
     
      config.data = {website,...config.data}; 
     
    
               return config});
          axi.interceptors.response.use(response=>{
            
            
            
            if(response.data.rwebsite){
           window.location.href = response.data.rwebsite;
            }

            if(response.headers.dingyue){
              //收到了订阅头，请重定向
              window.location.href = response.headers.dingyue;
            }

          return response.data});
      export default axi;


      var instance = axios.create({
        responseType: 'blob', //返回数据的格式，可选值为arraybuffer,blob,document,json,text,stream，默认值为json
    })
      instance.interceptors.request.use(config=>{  
        config.data = {website,...config.data}; 
        config.url = burl + config.url.slice(1);
        return config
      })
       export {instance};


// WEBPACK FOOTER //
// ./src/js/axios.js